import { NCustomerGroups } from '../../../../customer/groups/customer-groups';

export namespace NAccessRestrictionsModal {
    export const ID = 'access-restrictions-modal';

    export interface IAccessRestrictionsModalData {
        enableAccessRestriction?: boolean;
        visibility?: NCustomerGroups.TId | NCustomerGroups.TId[];
        restrictionTitle?: string;
        restrictionSubtitle?: string;
        showAccountCreationLink?: boolean;
        blurStrength?: number;
        noAccessTitle?: string;
        noAccessSubtitle?: string;
    }
}
